<template>
  <div class="row" v-if="!statistics.loading">
    <div class="col-sm-4">
      <stat
          :loading="statistics.loading"
          icon="mdi mdi-basket"
          :title="$t('pages.dashboard.bottom_cards.orders')"
          :value="statistics.data && statistics.data.order_total"
      >
      </stat>
    </div>

    <div class="col-sm-4">
      <stat
          :loading="statistics.loading"
          icon="mdi mdi-plus-box-multiple"
          :title="$t('pages.dashboard.bottom_cards.message_queue')"
          increase
          :value="statistics.data && statistics.data.queue_total"
      >
      </stat>
    </div>

    <div class="col-sm-4">
      <stat
          :loading="statistics.loading"
          icon="mdi mdi-cash"
          :title="$t('pages.dashboard.bottom_cards.sales')"
          increase
          :value="statistics.data && statistics.data.sales.amount + ' ' + statistics.data.sales.currency_code"
      >
      </stat>
    </div>
  </div>
</template>

<script>
import Stat from "@/components/widgets/stat";

export default {
  name: "BottomCards",
  props: ['statistics'],
  components: {
    Stat
  }
}
</script>

<style scoped>

</style>